import type { DesignerNodeData } from "../schemas/index.ts";
import { traverseNodeSubtree } from "../shared/index.ts";
import type { NodeImportLookup } from "./nodeImportLookup.ts";

export interface PreproceessDesignerNodeForImportOptions {
  lookup: NodeImportLookup;
  migrateSubtree: (node: DesignerNodeData) => DesignerNodeData;
}

export const preprocessDesignerNodeForImportCreate =
  ({ migrateSubtree, lookup: { addNewNodeId } }: PreproceessDesignerNodeForImportOptions) =>
  (originalNodes: DesignerNodeData[]): DesignerNodeData[] => {
    const nodes = originalNodes.map(migrateSubtree);

    for (const subtreeRootNode of nodes) {
      traverseNodeSubtree(subtreeRootNode, (node) => {
        addNewNodeId(node.id);
      });
    }

    return nodes;
  };

export type PreprocessDesignerNodeForImport = ReturnType<typeof preprocessDesignerNodeForImportCreate>;
